import { Page, PaginationParams } from '@/shared/api/pagination';
import type {
  HIType,
  HiTypeCreate,
  HITypeStatus,
  HiTypeUpdate,
} from '../model/hi-type';
import type { AxiosRequestConfig } from 'axios';

import { monitoringInstance } from '@/shared/api/api-instances/monitoring/api-instance';
import { ImportEntities } from '@/shared/api/import-contracts';

const baseURL = '/api/monitoring/v4/';
const defaultOptions = { baseURL };
export class HITypesAPI {
  static getTypes(params: PaginationParams, options?: AxiosRequestConfig) {
    return monitoringInstance.get<Page<HIType>>(`/hi/types`, {
      ...options,
      params: params,
    });
  }

  static getTypesList(options?: AxiosRequestConfig) {
    return monitoringInstance.get<HIType[]>(`/hi/types/list`, options);
  }

  static getHiType(hi_type_id: string, options?: AxiosRequestConfig) {
    return monitoringInstance.get<HIType>(`/hi/type/${hi_type_id}`, options);
  }

  static getHiTypeByName(hi_type_name: string, options?: AxiosRequestConfig) {
    return monitoringInstance.get<HIType>(
      `/hi/type/by_name/${hi_type_name}`,
      options,
    );
  }

  static createHiType(payload: HiTypeCreate, options?: AxiosRequestConfig) {
    return monitoringInstance.post<HIType>(`/hi/type`, payload, options);
  }

  static updateHiType(
    hi_type_id: string,
    payload: HiTypeUpdate,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.put<HIType>(
      `/hi/type/${hi_type_id}`,
      payload,
      options,
    );
  }

  static deleteType(
    hi_type_id: string,
    force?: boolean,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.delete(`/hi/type/${hi_type_id}`, {
      ...options,
      params: { force },
    });
  }

  // Сатусы HI
  static getStatuses(options?: AxiosRequestConfig) {
    return monitoringInstance.get<HITypeStatus[]>(`/hi/statuses`, options);
  }

  //Операторы статусов
  static async getStatusOperators() {
    const response = {
      data: {
        result: [
          { name: 'equals', label: 'Равно' },
          { name: 'in', label: 'Содержится' },
        ],
      },
    };
    return response;
  }

  static exportHiTypeV4(
    hi_types_names: string[],
    with_exporter = true,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.get('/hi/type/export/json', {
      ...defaultOptions,
      ...options,
      params: { with_exporter, hi_types_names },
      paramsSerializer: () => {
        const searchParams = new URLSearchParams();
        hi_types_names.forEach((name) =>
          searchParams.append('hi_types_names', name),
        );
        return searchParams.toString();
      },
    });
  }

  // static importFileHiType(formData: FormData, options?: AxiosRequestConfig) {
  //   return monitoringInstance.post<string>(
  //     '/import/hi_type/json_file',
  //     formData,
  //     options,
  //   );
  // }

  static analyzeHiTypesEntities(json: string, options?: AxiosRequestConfig) {
    return monitoringInstance.post('/import/hi_type/analyze', json, {
      ...defaultOptions,
      ...options,
    });
  }

  static executeHiTypesEntities(
    data: ImportEntities,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.post('/import/hi_type/execute', data, {
      ...defaultOptions,
      ...options,
    });
  }

  static validateImport(
    json: { hi_types: HIType[] },
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.post('/import/hi_type/validate', json, {
      ...defaultOptions,
      ...options,
    });
  }
}